import { useState, useEffect } from 'react';
import {
  getMySubscriptions,
  getPlanCatalog,
  isSubscriptionAccessActive,
} from '../services/subscriptionService';
import colors from '../design-system/colors';

/** Derive subscription tier from license array + role */
const getSubscriptionTier = (subscriptions, catalog, userRole) => {
  if (userRole === 'admin') return { label: 'Admin', color: colors.primary[700], bg: colors.primary[50], hasLicense: true };
  const active = (subscriptions || []).filter(isSubscriptionAccessActive);
  const subscription = active.find((item) => item.scope === 'individual') || active[0];
  if (!subscription) {
    return { label: 'Sin licencia', color: colors.neutral[600], bg: colors.neutral[100], hasLicense: false };
  }
  const plan = (catalog || []).find((item) => item.plan_key === subscription.plan_key && item.scope === subscription.scope);
  return {
    label: subscription.plan_key === 'trial-full'
      ? 'Prueba gratuita'
      : plan?.display_name || subscription.plan_key,
    color: colors.success[700],
    bg: colors.success[50],
    hasLicense: true,
  };
};

/**
 * Hook to get the current user's subscription tier.
 * Returns { label, color, bg } or null while loading.
 */
export function useLicenseTier(userId, userRole) {
  const [tier, setTier] = useState(null);

  useEffect(() => {
    if (!userId) {
      setTier(getSubscriptionTier([], [], userRole));
      return;
    }
    let cancelled = false;
    Promise.all([getMySubscriptions(), getPlanCatalog()])
      .then(([subscriptions, catalog]) => {
        if (!cancelled) setTier(getSubscriptionTier(subscriptions, catalog, userRole));
      })
      .catch(() => {
        if (!cancelled) setTier(getSubscriptionTier([], [], userRole));
      });
    return () => { cancelled = true; };
  }, [userId, userRole]);

  return tier;
}

export { getSubscriptionTier };
